import { ProgressContainer, Progress } from './ProgressBar-styled'

export default function ProgressBar({ height, width, completionRate }) {
	return (
		<ProgressContainer height={height} width={width}>
			<Progress percent={completionRate} />
		</ProgressContainer>
	)
}
